'use client'

export const envScriptId = 'env-config'

export const getRuntimeEnv = () => {
  const script = document.getElementById(envScriptId) as HTMLScriptElement
  return script ? JSON.parse(script.innerText) : undefined
}
